import {
  getTaxPaymentPeriods,
  getUsersLicensesAsync,
  getLicenseAsync,
  getLookupLicenseAsync,
  getAllLicensesForUserAsync,
  getUsersRenewableLicensesAsync,
  createNewLicense,
  updateLicense,
  renewLicense,
  bulkRenewLicenses,
  calculateLicenseFee,
  calculateLicenseRenwalFee,
  calculateBulkLicenseRenewalFee,
  getPropertyContactsByApplicationNumber,
  getPermitActionability,
  getReportingHistoryByApplicationNumber,
  getLicensesRentalscape,
  getCallerIdentityRentalscape,
  getLicenseByApnRentalscape,
  getLicenseByApplicationNumberRentalscape,
  updateLicenseRentalscape,
  getLicensesByAPN,
} from './licenses';
import { getTranslationsAsync, getExpressConfig } from './misc';
import { getStripePublicKey, payByCreditCard, payByACHDirectDebit, payByACHCredit, payByCheck, calculateMultiPropertyTotAsync, checkLicensePayment, checkTaxPayment, payNothingGeneric, payNothing, payGeneric } from './payment';
import { lookupAddress, lookupAPNAddress, lookupAddressAPN } from './place';
import { fetchDocumentUploadToken, uploadDocument } from './upload';
import { getCognitoUserIdByEmailAddressAsync, getUserDetailsAuthTokenAsync, createAccountAsync, editPersonDetailsAsync, getUserByEmailAddressRentalscapeAsync } from './user';

const apiAccess = {
  getCognitoUserIdByEmailAddressAsync,
  getUserDetailsAuthTokenAsync,
  createAccountAsync,
  editPersonDetailsAsync,
  getTaxPaymentPeriods,
  calculateMultiPropertyTotAsync,
  lookupAddress,
  lookupAPNAddress,
  getUsersLicensesAsync,
  getLicenseAsync,
  getLicensesByAPN,
  getLookupLicenseAsync,
  getAllLicensesForUserAsync,
  getUsersRenewableLicensesAsync,
  createNewLicense,
  updateLicense,
  renewLicense,
  bulkRenewLicenses,
  calculateLicenseFee,
  calculateLicenseRenwalFee,
  calculateBulkLicenseRenewalFee,
  fetchDocumentUploadToken,
  uploadDocument,
  getStripePublicKey,
  payByCreditCard,
  payByACHDirectDebit,
  payByACHCredit,
  payByCheck,
  payGeneric,
  checkTaxPayment,
  checkLicensePayment,
  payNothing,
  payNothingGeneric,
  getPropertyContactsByApplicationNumber,
  getPermitActionability,
  getReportingHistoryByApplicationNumber,
  getTranslationsAsync,
  getExpressConfig,
  getLicensesRentalscape,
  getCallerIdentityRentalscape,
  getLicenseByApnRentalscape,
  getLicenseByApplicationNumberRentalscape,
  updateLicenseRentalscape,
  getUserByEmailAddressRentalscapeAsync,
};

export { lookupAddress, lookupAPNAddress, lookupAddressAPN };

export default apiAccess;
